import { render, staticRenderFns } from "./pin-list.vue?vue&type=template&id=05a0788a&scoped=true"
import script from "./pin-list.vue?vue&type=script&lang=js"
export * from "./pin-list.vue?vue&type=script&lang=js"
import style0 from "./pin-list.vue?vue&type=style&index=0&id=05a0788a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0788a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/pin-list.vue
// module id = akCw
// module chunks = 0